module.exports = __webpack_public_path__ + "static/img/Aemis_logo.832225e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Aemis_logo.png
// module id = iVEN
// module chunks = 0